import { useRef, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { downloadExcel } from "@/lib/files";
import { Button } from "@/components/ui/button";
import { Upload, FileDown, Loader2 } from "lucide-react";

export const DouaneImport = ({ kind, societeId, onDone }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [rapport, setRapport] = useState(null);

  const onFile = async (e) => {
    const f = e.target.files[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/douane-import", fd, { params: { kind, societe_id: societeId || "all" }, headers: { "Content-Type": "multipart/form-data" } });
      setRapport(data);
      toast[data.ignores.length ? "warning" : "success"](`${data.crees} document(s) importé(s)${data.ignores.length ? `, ${data.ignores.length} ligne(s) ignorée(s)` : ""}`);
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Import impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="outline" className="gap-1" onClick={() => downloadExcel(`/douane-import/modele?kind=${kind}`, `modele-${kind}`)} data-testid="douane-modele-btn"><FileDown className="h-4 w-4" /> Modèle Excel</Button>
      <Button variant="outline" className="gap-1" disabled={busy} onClick={() => ref.current.click()} data-testid="douane-import-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} Importer
      </Button>
      <input ref={ref} type="file" accept=".xlsx,.csv" className="hidden" onChange={onFile} data-testid="douane-import-input" />
      {rapport?.ignores.length > 0 && (
        <div className="basis-full rounded-lg border border-amber-300 bg-amber-50 p-3 text-xs text-amber-900" data-testid="douane-import-rapport">
          <p className="font-semibold mb-1">Lignes ignorées :</p>
          {rapport.ignores.map((i) => <p key={i.ligne}>Ligne {i.ligne} : {i.raison}</p>)}
        </div>
      )}
    </div>
  );
};
